<template>
    <div>
        <div>
            <a-button type="link" v-if="isconfig" @click="showSelecter">配置规则管理</a-button>
            <a-input v-else @click="showSelecter" :readOnly="true" :value="selectedItem.length > 0 ? selectedItem[0].rangerulename  : '点击选择'" style="width:150px;" placeholder="点击选择">
                <a-icon slot="prefix" type="control"  theme="filled" style="color:#ffe792;font-size:18px;" />
                <a-icon slot="suffix" type="select"   style="color:#1890ff;font-size:18px;" />
            </a-input>
        </div>
        <a-modal :title="title" :visible="isShow" :confirm-loading="confirmLoading" width="750px"
            @cancel="handleCancel">
            <!-- 列表 -->
            <div v-show="isList" class="pb50">
                <a-input style="width: 50%;" class="mt10" v-model="searchVal" placeholder="关键字" default-value=""
                    @keyup.enter.native="loadTable" />
                <a-button type="primary" class="ml10" @click="loadTable">搜索</a-button>
                <a-button type="link" class="fr mr10 mt10" @click="handleNew">+新增规则</a-button>
                <a-table class="mt10" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:'radio'}"
                    :columns="columns" :data-source="list" rowKey="rangerule" :pagination="false" :loading="tableLoading">
                    <template slot="operation" slot-scope="text, record">
                        <a-button type="link" @click="handleEdit(record)">编辑</a-button>
                        <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                            <a class="tableLink" href="javascript:;">删除</a>
                        </a-popconfirm>
                    </template>
                </a-table>
                <a-pagination class="mt20" v-model="pagination.current" :total="pagination.total"
                    @change="handlePageChange" style="float:right;" show-less-items />
            </div>
            <!-- 新增编辑 -->
            <div v-show="!isList">
                <a-row>
                    <a-col :span="24">
                        <a-button type="link" class="fr mr10 mb20" @click="handleList">返回搜索列表</a-button>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model :model="record" ref="ruleForm" :layout="formItemLayout" :rules="rules">
                            <a-form-model-item ref="rangerule" label="配置规则" prop="rangerule"  :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                                <a-input  v-model="record.rangerule" :readOnly="record.id != ''" />
                            </a-form-model-item>

                            <a-form-model-item ref="rangerulename" label="配置规则名称" prop="rangerulename"  :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                                <a-input  v-model="record.rangerulename" />
                            </a-form-model-item>

                            <a-form-model-item :wrapper-col="{ span: 14, offset: 10 }">
                                <a-button type="primary" @click="handleSave" :loading="confirmLoading">
                                    保存
                                </a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </a-col>
                </a-row>
            </div>

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button v-if="!isconfig" key="submit" type="primary" :loading="confirmLoading" @click="handleOk"  v-show="isList">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>

const columns = [
    {
        title: '配置规则名称',
        dataIndex: 'rangerulename',
        align: 'center',
        width: 100,
    },
    {
        title: '配置规则',
        dataIndex: 'rangerule',
        align: 'center',
        width: 150,
    },
    
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 80,
        scopedSlots: { customRender: 'operation' },
    }
];
export default {
    data() {
        return {
            title:'配置规则',
            isShow:false,
            confirmLoading:false,
            editorShow:false,
            searchVal:'',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
            isList:true,
            columns,
            list:[],
            selectedRowKeys: [],
            selectedItem:[],
            tableLoading:false,

            //新增编辑
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            rules: {
                rangerule:[
                    { required: true, message: '请输入编码规则', trigger: 'blur' },
                ],
                rangerulename:[
                    { required: true, message: '请输入编码规则名称', trigger: 'blur' },
                ],
            },
            formItemLayout:'horizontal',
            record:{
                platformcode:'',
                rangerule:'',
                rangerulename:'',
                createuser:'',
                id:''
            }
        }
    },
    props:{
        isconfig:{
            type:Boolean,
            default:false,
        },
        platformcode:String,
    },
    methods: {
        //打开选择器
        showSelecter(){
            this.loadTable()
            this.isShow = true;
        },
        //返回搜索列表
        handleList(){
            this.resetForm();
            this.loadTable();
            this.isList = true;
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        //选择
        handleOk(){
            this.$emit('rangeruleChange',this.selectedItem);
            this.isShow = false;
        },
        //取消模态框
        handleCancel(){
            this.isShow = false;
        },
        //新增
        handleNew(){
            //初始化
            this.record = {
                platformcode:this.platformcode,
                rangerule:'',
                rangerulename:'',
                createuser:this.G.getCurrentUser().username,
                id:''
            }
            this.isList = false;
        },
        //编辑
        handleEdit(record){
            //初始化
            this.record = {
                platformcode:record.platformcode,
                rangerule:record.rangerule,
                rangerulename:record.rangerulename,
                createuser:undefined,
                id:record.id
            }
            this.isList = false;
        },
        //删除
        handleDelete(record){
            let that = this;
            that.$store.dispatch({
                type: "cloudconfig/delrule",
                params: {id: record.id,rangerule:record.rangerule,platformcode:record.platformcode}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.loadTable()
                }
            });
        },
        //新增或编辑保存
        handleSave(){
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    if(that.record.id != ''){
                        that.$store
                            .dispatch({
                                type: "cloudconfig/updaterule",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleList();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else {
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "cloudconfig/addrule",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleList();
                                    that.confirmLoading = false;

                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //分页
        handlePageChange(params_page){
            this.loadTable(params_page)
        },
        //加载列表
        loadTable(pageNum){
            if(!pageNum){
                pageNum = 1
            }
            let that = this;
            that.tableLoading = true;
            let c_params = {
                pageSize:that.pagination.pageSize,
                page:pageNum,
                platformcode:that.platformcode,
                keyword:that.searchVal,
                urlparams:false,
            }
            
            that.$store.dispatch({
                type: "cloudconfig/queryrulespage",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                if(res.data.success == 1){
                    let result = res.data.data;
                    that.list = result.list;
                    that.pagination.total = result.totalRecords;
                    that.pagination.pageSize = result.pageSize;
                    that.pagination.current = result.page;
                }
                else{
                    that.message.error('获取配置规则列表失败')
                }
                that.tableLoading = false;

            })
        },
        onSelectChange(selectedRowKeys,selectedItem) {
            this.selectedItem = selectedItem;
            this.selectedRowKeys = selectedRowKeys;
        },
        init(rangerule,rangerulename){
            if(rangerule && rangerulename){
                this.selectedItem = [];
                let sItem = {
                    rangerule:rangerule,
                    rangerulename:rangerulename
                }
                this.selectedItem.push(sItem);
                this.selectedRowKeys = [];
                this.selectedRowKeys.push(rangerule)
            }
        }
    },
    mounted() {
    },
    components:{
    },

};
</script>

<style>
    .ant-modal-body{
        padding-top: 2px;
    }

    .ant-input-affix-wrapper .ant-input:not(:first-child) {
        padding-left: 35px;
        color: gray;
        cursor: pointer;
    }
</style>
